/**
 * Renders ONE gate's named reason — nothing more (Task 18). This is the ONE
 * place a refusal becomes text in this app, so the online path
 * (`test/data-layer.test.tsx`'s `DraftScreen`, the only rendering of a
 * refusal that existed anywhere in this repo before this task) and the Sync
 * tray's drain-time refusals (`outbox/repair.tsx`'s `RefusedEntry`) show
 * IDENTICAL markup for the SAME gate reason — task brief: "the tray must
 * not grow a second vocabulary for the same gate reasons."
 *
 * A `Refusal`'s `message` (`@gridfit/core/gates`'s `defineRefusal`) is
 * already the complete, human-readable sentence the gate itself produced
 * (`quoteHasNoLines.render`, and every refusal like it) — this component's
 * only job is to put that sentence on screen verbatim, never to re-word,
 * summarise or categorise it into a smaller vocabulary of its own. `code` is
 * carried as a `data-` attribute rather than shown as text: it identifies
 * WHICH gate fired for tooling/tests (`screen.getByText`'s human-readable
 * match should be the sentence, not the code), not a second, competing
 * label for the same reason.
 */
export function RefusalReason({ code, message }: { code: string; message: string }) {
  return <p data-refusal-code={code}>{message}</p>
}
